let STATE_ID_STATISTICS_BASE_URL = "";
let COUNTRY_STATISTICS_BASE_URL = "";
let STATE_STATISTICS_BASE_URL = "";
let SECTOR_STATISTICS_BASE_URL = "";
let CAMPAIGN_2021 = "";
let CAMPAIGN_2020 = "";
let CAMPAIGN_2022 = "";
let CAMPAIGN_2023 = "";
let CAMPAIGN_2024 = "";
let CAMPAIGN_2025 = "";
let CAMPAIGN_2026 = "";

const url = window.location.href;


if (url.match(/dev/gi) || url.match(/localhost/gi)) {
   STATE_ID_STATISTICS_BASE_URL =
    "https://us-central1-devmappser.cloudfunctions.net/firstPoliticalDivitionStatistics?";
   COUNTRY_STATISTICS_BASE_URL =
    "https://us-central1-devmappser.cloudfunctions.net/countryStatistics?campaignId=";
   STATE_STATISTICS_BASE_URL =
    "https://us-central1-devmappser.cloudfunctions.net/stateStatistics?campaignId=";

   SECTOR_STATISTICS_BASE_URL = "https://us-central1-devmappser.cloudfunctions.net/sectorStatistics";
 

   CAMPAIGN_2020 = "aXY3IUXGOR8Jt9wYvgHY";
   CAMPAIGN_2021 = "EFhM8QmVa3IlyylWDgR0";
   CAMPAIGN_2022 = "U4fQEgSxuVPCqtyy6zgt";
   CAMPAIGN_2023 = "U4fQEgSxuVPCqtyy6zgt";
   CAMPAIGN_2024 = "sm8BEuyG8w3FxLuLGfb7";
   CAMPAIGN_2025 = "zVtJsFOtg5pZ7FnWlAAi";
   CAMPAIGN_2026 = "qo7NLmWgX6xu1sDwGn9A";

} else {
   STATE_ID_STATISTICS_BASE_URL =
    "https://us-central1-cnesimulacro.cloudfunctions.net/firstPoliticalDivitionStatistics?";
   COUNTRY_STATISTICS_BASE_URL =
    "https://us-central1-cnesimulacro.cloudfunctions.net/countryStatistics?campaignId=";
   STATE_STATISTICS_BASE_URL =
    "https://us-central1-cnesimulacro.cloudfunctions.net/stateStatistics?campaignId=";

   SECTOR_STATISTICS_BASE_URL = "https://us-central1-cnesimulacro.cloudfunctions.net/sectorStatistics";


   CAMPAIGN_2020 = "aXY3IUXGOR8Jt9wYvgHY";
   CAMPAIGN_2021 = "AJiuGx95brKhPlz53xk1";
   CAMPAIGN_2022 = "qgLiu0OW7NO0a3S6J60G";
   CAMPAIGN_2023 = "qgLiu0OW7NO0a3S6J60G";
   CAMPAIGN_2024 = "sm8BEuyG8w3FxLuLGfb7";
   CAMPAIGN_2025 = "zVtJsFOtg5pZ7FnWlAAi";
   CAMPAIGN_2026 = "qo7NLmWgX6xu1sDwGn9A";

}

export {
  STATE_ID_STATISTICS_BASE_URL,
  COUNTRY_STATISTICS_BASE_URL,
  STATE_STATISTICS_BASE_URL,
  SECTOR_STATISTICS_BASE_URL,
  CAMPAIGN_2020,
  CAMPAIGN_2021,
  CAMPAIGN_2022,
  CAMPAIGN_2023,
  CAMPAIGN_2024,
  CAMPAIGN_2025,
  CAMPAIGN_2026
};
